
import React, { useState, useEffect } from 'react';

const loadingMessages = [
  "Parsing your resume structure...",
  "Translating content to professional English...",
  "Checking for ATS compatibility...",
  "Optimizing wording with action verbs...",
  "Mapping skills to industry keywords...",
  "Finalizing your globally-ready resume...",
];

const LoadingScreen: React.FC = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % loadingMessages.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center text-center pt-20">
      <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
      <h2 className="mt-8 text-2xl font-semibold text-slate-800">Analyzing Your Resume</h2>
      <p className="mt-2 text-slate-600 transition-opacity duration-500">
        {loadingMessages[currentMessageIndex]}
      </p>
    </div>
  );
};

export default LoadingScreen;
